"use client";

import { useContext } from "react";
import { LocaleChannelContext, type LocaleChannelContextValue } from "./locale-channel-provider";

/**
 * Consume the LocaleChannelProvider context. Throws if used outside a provider
 * because the provider is mounted unconditionally in the main layout.
 */
export function useLocaleChannelState(): LocaleChannelContextValue {
	const ctx = useContext(LocaleChannelContext);
	if (!ctx) {
		throw new Error("useLocaleChannelState must be used inside <LocaleChannelProvider>");
	}
	return ctx;
}
